import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import EngagementSlide from 'src/v2/components/layout/website/LandingEngagement';
import LandingFooter from 'src/v2/components/layout/website/LandingFooter';
import RoadmapLandingSlide from 'src/v2/components/layout/website/roadmap/RoadmapLandingSlide';
import RoadmapSlide from 'src/v2/components/layout/website/roadmap/RoadmapSlide';
import { FadeContainer } from 'src/v2/components/ui/containers/fade';

const GovernancePage = () => {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 1);
  });

  return (
    <Box>
      <FadeContainer visible={visible ? 1 : 0} time={0.5}>
        <RoadmapLandingSlide />

        <RoadmapSlide />

        <EngagementSlide />
      </FadeContainer>
      <LandingFooter />
    </Box>
  );
};

export default GovernancePage;
